import React from 'react';
import PropTypes from 'prop-types';

import { getListChildNewLocation } from '../../../../../../../common/elements/utils/elementLocationUtils';

import FileUploadForm from '../../../../../../components/tools/files/FileUploadForm';
import StyledButton from '../../../../../../components/buttons/StyledButton';

import { ELEMENT_CREATION_SOURCES } from '../../../../../../../common/elements/elementConstants';

import './ImagePopupUploadForm.scss';

const getElementLocation = ({ currentBoardId }) => getListChildNewLocation({ listId: currentBoardId });

const ImagePopupUploadForm = (props) => (
    <FileUploadForm
        {...props}
        className="ImagePopupUploadForm"
        getElementLocation={getElementLocation}
        creationSource={ELEMENT_CREATION_SOURCES.IMAGE_UPLOAD_POPUP}
        accept="image/*"
    >
        {(handleFileUpload) => (
            <div>
                <img src={require('./image-upload-form-illustration.png')} width={150} height={99} draggable={false} />

                <StyledButton className="primary" onClickFn={handleFileUpload}>
                    Upload an image
                </StyledButton>

                <div className="tip">Tip: the easiest way to upload an image is to drag it straight into a board.</div>
            </div>
        )}
    </FileUploadForm>
);

ImagePopupUploadForm.propTypes = {
    currentBoardId: PropTypes.string,
};

export default ImagePopupUploadForm;
